import { render, staticRenderFns } from "./shenzhen_activity.vue?vue&type=template&id=42a1f4b4&scoped=true&"
import script from "./shenzhen_activity.vue?vue&type=script&lang=js&"
export * from "./shenzhen_activity.vue?vue&type=script&lang=js&"
import style0 from "./shenzhen_activity.vue?vue&type=style&index=0&id=42a1f4b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a1f4b4",
  null
  
)

export default component.exports